import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.92 8.52A2.184 2.184 0 0 1 8 4.153a2.184 2.184 0 0 1 .08 4.367.642.642 0 0 0-.16 0ZM8 14.667a6.623 6.623 0 0 1-4.493-1.747c.066-.627.466-1.24 1.18-1.72 1.826-1.213 4.813-1.213 6.626 0 .714.48 1.114 1.093 1.18 1.72A6.622 6.622 0 0 1 8 14.667Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 14.667A6.667 6.667 0 1 1 8 1.334a6.667 6.667 0 0 1 0 13.333Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
